export default "__VITE_ASSET__DIGuf9eo__"